import { render, staticRenderFns } from "./AdminUserAcademies.vue?vue&type=template&id=cd5246dc&scoped=true&lang=pug&"
import script from "./AdminUserAcademies.vue?vue&type=script&lang=ts&"
export * from "./AdminUserAcademies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5246dc",
  null
  
)

export default component.exports